import { Modal, ModalDialog, DialogContent, DialogTitle, FormControl, FormLabel, Input, Grid, Drawer, ModalClose, Divider, Checkbox, DialogActions, Button, Box, Textarea } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import { eventNames } from "process";
import { FollowUp } from "../Pages/FollowUps";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

interface FollowUpDialogProps {
	followUp?: FollowUp;
	close: Function;
	open: boolean;
}

export default function FollowUpDialog(props: FollowUpDialogProps) {
	const [followup, setFollowup] = React.useState<FollowUp>({
							FollowUpID: "",
							BuildingName: "",
							Address: "",
							Lost: false,
							Maintenance: false,
							Modern: false,
							Repair: false,
							FollowUps: "",
							Landings: "",
							Notes: "",
							DateAssessed: new Date(),
							DateContract: new Date(),
							Contact1Name: "",
							Contact1Phone: "",
							Contact1Email: "",
							Contact2Name: "",
							Contact2Phone: "",
							Contact2Email: "",
							Contact3Name: "",
							Contact3Phone: "",
							Contact3Email: "",
	
						} as FollowUp);

	React.useEffect(() => {
		setFollowup(props.followUp ?? {} as FollowUp);
	}, [props.followUp]);

	const save = () => {
		const f = {
			FollowUpID: followup.FollowUpID ?? (null as any),
			BuildingName: followup.BuildingName,
			Address: followup.Address,
			Contact1Name: followup.Contact1Name,
			Contact1Phone: followup.Contact1Phone,
			Contact1Email: followup.Contact1Email,
			Contact2Name: followup.Contact2Name,
			Contact2Phone: followup.Contact2Phone,
			Contact2Email: followup.Contact2Email,
			Contact3Name: followup.Contact3Name,
			Contact3Phone: followup.Contact3Phone,
			Contact3Email: followup.Contact3Email,
			DateAssessed: followup.DateAssessed,
			DateContract: followup.DateContract,
			Landings: followup.Landings,
			Modernization: followup.Modern,
			Maintenance: followup.Maintenance,
			Repair: followup.Repair,
			FollowUps: followup.FollowUps,
			Lost: followup.Lost,
			Notes: followup.Notes,
		};
		fetch("Inspection/SaveFollowUp", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify(f),
		}).then((x) => close());
	};

	const close = () => {
		props.close();
	};

	const sizes = {
		sm: 12,
		md: 6,
		lg: 3,
	};

	const threeSizes = {
		sm: 12,
		md: 6,
		lg: 4,
	};
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<Drawer anchor="right" open={props.open} size="lg">
				<ModalClose onClick={() => props.close()} />
				<DialogTitle>Follow Up Form</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Building Info</FormLabel>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Building Name</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, BuildingName: event.target.value });
									}}
									value={followup?.BuildingName}
									name="building_name"></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Address</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Address: event.target.value });
									}}
									value={followup?.Address}
									name="address"></Input>
							</FormControl>
						</Grid>
						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Building Info</FormLabel>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 1 Name</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact1Name: event.target.value });
									}}
									value={followup?.Contact1Name}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 1 Phone</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact1Phone: event.target.value });
									}}
									value={followup?.Contact1Phone}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 1 Email</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact1Email: event.target.value });
									}}
									value={followup?.Contact1Email}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 2 Name</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact2Name: event.target.value });
									}}
									value={followup?.Contact2Name}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 2 Phone</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact2Phone: event.target.value });
									}}
									value={followup?.Contact2Phone}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 2 Email</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact2Email: event.target.value });
									}}
									value={followup?.Contact2Email}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 3 Name</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact3Name: event.target.value });
									}}
									value={followup?.Contact3Name}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 3 Phone</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact3Phone: event.target.value });
									}}
									value={followup?.Contact3Phone}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Contact 3 Email</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Contact3Email: event.target.value });
									}}
									value={followup?.Contact3Email}></Input>
							</FormControl>
						</Grid>
						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Elevators</FormLabel>
						</Grid>
						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>How many landings?</FormLabel>
								<Input
									onChange={(event) => {
										setFollowup({ ...followup, Landings: event.target.value });
									}}
									value={followup?.Landings}></Input>
							</FormControl>
						</Grid>
						<Grid {...threeSizes}>
							<DatePicker
								slotProps={{
									textField: { variant: "standard", sx: { height: "100%", width: "100%", verticalAlign: "bottom", justifyContent: "end" } },
								}}
								label="Date Attended"
								value={followup.DateAssessed}
								format="MM/dd/yyyy"
								sx={{ height: "100%", width: "100%" }}
								onChange={(value) => {
									setFollowup({ ...followup, DateAssessed: value as Date });
								}}
							/>
						</Grid>
						<Grid {...threeSizes}>
							<DatePicker
								slotProps={{
									textField: { variant: "standard", sx: { height: "100%", width: "100%", justifyContent: "end" } },
								}}
								label="Date of Contract"
								value={followup.DateContract}
								format="MM/dd/yyyy"
								sx={{ height: "100%", width: "100%" }}
								onChange={(value) => {
									setFollowup({ ...followup, DateContract: value as Date });
								}}
							/>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Maintenance?</FormLabel>
								<Checkbox
									onChange={(event) => {
										setFollowup({ ...followup, Maintenance: event.target.checked });
									}}
									checked={followup.Maintenance}
								/>
							</FormControl>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Modernization?</FormLabel>
								<Checkbox
									onChange={(event) => {
										setFollowup({ ...followup, Modern: event.target.checked });
									}}
									checked={followup.Modern}
								/>
							</FormControl>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Repair?</FormLabel>
								<Checkbox
									onChange={(event) => {
										setFollowup({ ...followup, Repair: event.target.checked });
									}}
									checked={followup.Repair}
								/>
							</FormControl>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Lost?</FormLabel>
								<Checkbox
									onChange={(event) => {
										setFollowup({ ...followup, Lost: event.target.checked });
									}}
									checked={followup.Lost}
								/>
							</FormControl>
						</Grid>
						<Grid xs={12}>
							<FormControl>
								<FormLabel>Notes</FormLabel>
								<Textarea
									minRows={5}
									maxRows={5}
									onChange={(event) => {
										setFollowup({ ...followup, Notes: event.target.value });
									}}
									value={followup?.Notes}></Textarea>
							</FormControl>
						</Grid>
						<Grid xs={12}>
							<FormControl>
								<FormLabel>Follow Up</FormLabel>
								<Textarea
									minRows={5}
									maxRows={5}
									onChange={(event) => {
										setFollowup({ ...followup, FollowUps: event.target.value });
									}}
									value={followup?.FollowUps}></Textarea>
							</FormControl>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
						<Button size="lg" color="primary" onClick={close} sx={{ mx: 1 }}>
							Close
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</LocalizationProvider>
	);
}
